import {
  SET_ACTUAL_STATUS,
  PUSH_ACTUAL_STATUS,
  SET_BEACON_STATUS,
  PUSH_BEACON_STATUS,
  SET_UNREAD_NOTIFICATIONS_COUNT,
  SET_CURRENT_ACCOUNT_DATA
} from './actionTypes';

export const setActualStatus = status => ({
  type: SET_ACTUAL_STATUS,
  payload: status
});
export const pushActualStatus = status => ({
  type: PUSH_ACTUAL_STATUS,
  payload: status
});
export const setBeaconStatus = status => ({
  type: SET_BEACON_STATUS,
  payload: status
});
export const pushBeaconStatus = status => ({
  type: PUSH_BEACON_STATUS,
  payload: status
});
export const setUnreadNotificationsCount = count => ({
  type: SET_UNREAD_NOTIFICATIONS_COUNT,
  payload: count
});

export const setCurrentAccountData = customerData => ({
  type: SET_CURRENT_ACCOUNT_DATA,
  payload: customerData
});
